import bankTenpoPrepago from '../../banksPNG/bankTenpoPrepago.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoTenpoIcon = ({ width = '17', height = '17', alt = 'Banco Tenpo' }: IconProps) => (
	<img src={bankTenpoPrepago} width={width} height={height} alt={alt} />
);
